export const environment = {
    production: false,
    ApiAppUrl: 'https://idprpapitest.clavisco.com/',
    ApiUIUrl: 'https://idprptest.clavisco.com/',
    env : 'Staging',
    recatchaSiteKey: '6Lc9mfIqAAAAANTsS_Lt_5T7xejQahT6aYArGzp4'
  };